import { useContext } from 'react';

import { isNil } from 'ramda';
import { useHistory } from 'react-router-dom';

import { getTableData } from 'components/Pages/Admin/Itineraries/utils';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { transformBEScheduleToOverviewForm } from 'store/itineraryDetails/transform';
import { confirmAlert } from 'utils/alert';
import { getDateFormat } from 'utils/date';
import isNoData from 'utils/isNoData';
import { useItinerariesItemContext } from 'utils/itineraries/context';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { ITINERARY_STEPS } from 'utils/itineraries/itinerary/map';

export const useManifestTable = () => {
  const history = useHistory();
  const getStepPath = useItinerariesItemStepPath(ITINERARIES_ITEM_TYPES.ITINERARY);
  const itinerariesItemContext = useItinerariesItemContext();
  const isInsideItinerariesItemBuilder = !isNil(itinerariesItemContext);
  const { page: guestPortal } = useContext(LandingPageContext);

  const getItineraryDetails = (data) => {
    if (isNoData(data)) {
      return [];
    }

    const scheduleData = transformBEScheduleToOverviewForm(guestPortal?.scheduleType, data, {
      translate: true,
      translationFormat: '%B %-d',
      translationDateFormat: getDateFormat(guestPortal?.settings?.displayDatesDdMmYyyy),
    }).map((item) => {
      return {
        date: {
          formattedRange: item.formattedRange,
          formattedNumberOfNights: item.formattedNumberOfNights,
        },
        details: item.detailsText,
        rooming: item.accommodationText,
      };
    });

    return getTableData(scheduleData, 0);
  };

  const itineraryDetails = getItineraryDetails(guestPortal?.schedules);

  const goToItinerary = () => {
    if (isInsideItinerariesItemBuilder) {
      confirmAlert({
        confirmButtonText: 'Go to Itinerary',
        title: (
          <>
            Edits to this Safari Manifest can only be done in the Itinerary Details Tab. <br /> Do you want to go there
            now?
          </>
        ),
        onConfirm: () => {
          history.push(getStepPath(ITINERARY_STEPS.DETAILS, guestPortal?.itinerary.id));
        },
      });
    }
  };

  return {
    itineraryDetails,
    goToItinerary,
  };
};
